import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { otpCodeSubmit } from '@/redux/slices/auth';
import MfaInputForm from '@/features/auth/components/MfaInputForm';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '@/redux/root';
import { clearMfaRequired } from '@/redux/slices/auth';
import { useAdminCheckQuery } from '@/redux/api/auth';

interface MfaVerificationModalProps {
  context?: string | null;
}

const MfaVerificationModal: React.FC<MfaVerificationModalProps> = ({
  context = 'This action requires two-factor authentication.',
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { data: user } = useAdminCheckQuery();
  const { locked, allowSkipMfa } = useSelector((state: AppState) => state.auth);

  const userLocked = !!user?.mfaSettings?.otpLockedUntil || locked;

  const handleCodeSubmit = async (code: string) => {
    dispatch(otpCodeSubmit(code));
  };

  const cancelMfa = () => {
    dispatch(clearMfaRequired());
  };

  return (
    <Modal isOpen className="modal-lg" centered>
      <ModalHeader>
        Two-Factor Authentication Required
        {allowSkipMfa && (
          <Button color="link" className="p-0" onClick={cancelMfa}>
            <i className="ri-skip-forward-line"></i>
          </Button>
        )}
      </ModalHeader>
      <ModalBody>
        {userLocked && (
          <Alert color="danger" className="mb-4">
            <i className="ri-lock-line me-2"></i>
            <strong>Account Locked</strong>
            <br />
            Your account has been locked
          </Alert>
        )}

        <div className="mb-3">
          <p className="text-muted">{context}</p>
        </div>

        <MfaInputForm onSubmit={handleCodeSubmit} disabled={userLocked} />
      </ModalBody>
    </Modal>
  );
};

export default MfaVerificationModal;
